export const initialState = {
    newsList: [],
    activeNews:null
  };
